import { Feather, Ionicons, MaterialIcons } from '@expo/vector-icons';
import { cssInterop } from 'nativewind';

/**
 * Ícones aceitam `className="text-neutral-500"`: a cor vem do token e troca
 * com o tema. O `@expo/vector-icons` aplica `style` depois da prop `color`,
 * então a classe vence. Importado uma vez no `app/_layout.tsx`.
 */
for (const Icon of [Ionicons, Feather, MaterialIcons]) {
  cssInterop(Icon, { className: 'style' });
}
